<template>


    <section class="bg-lifeboost-blue-light">

        <div class="">
            <div class="grid grid-cols-12 bg-lifeboost-blue-light gap-x-8">
                <div class="items-center md:col-span-7 col-span-12 px-4 bg xl:ml-[calc((100vw_-_1280px)_/_2)] grid">

                
                   <div class="py-8 md:py-20 xl:py-0">
                    <h3 class="mb-4 font-bold h1 lg:pr-10">
                            Frosted Sugar Cookie

                        </h3>

                        <p class="pr-4 textp lg:pr-20">
                            Bold, robust, rich Arabica coffee and sweet, buttery frosted sugar cookies combine to offer
                            you a cup filled with simple familiarity and incredibly satisfying flavor.

                            <br/><br/>
                            Often considered the most simple cookie, when flavors of frosted sugar cookies - rich,
                            creamy butter, velvety vanilla, soft and subtle sweetness - collide with single origin,
                            rainforest mountain shade grown, hand selected, perfectly roasted, premium coffee beans the
                            result is a flavor overwhelmingly delicious and anything but ordinary.
                        </p>
                   </div>
                   
                </div>
                <div class="col-span-12 md:col-span-5">
                    <nuxt-img width="689" height="558" format="webp" src="/assets/images/image-section-1.jpg"  sizes="xs:330px sm:440px md:745vw lg:388px xl:689"
                        alt="section image" class="object-cover w-full h-full" preload />



                </div>
            </div>
        </div>
    </section>


</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'TextWhitImage',
    ignored: true
})

</script>